/* responsive header */

const breakhandler = (breakpoint) => {
  if (breakpoint.matches) {
    document.querySelector('body').classList.replace('mobile', 'desktop')
  } else {
    document.querySelector('body').classList.replace('desktop', 'mobile')
  }
}

const breakpoint = window.matchMedia('(min-width: 992px)')
breakhandler(breakpoint)
breakpoint.addListener(breakhandler)

/* handle mobile menu toggle */

$('#hamburger-toggle').click(function() {
  /* close mobile menu if already open */
  if ($("ul.menu.mobile").hasClass("show")) {
    $("ul.menu.mobile").removeClass("show");
    $("#hamburger-toggle").attr("aria-expanded", "false");
  }
  /* open mobile menu if closed */
  else {
    $("ul.menu.mobile").addClass("show");
    $("#hamburger-toggle").attr("aria-expanded", "true");
  }
})